import React, { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import classNames from 'classnames';
import useBlackFridayBanner from 'Hooks/Common/useBlackFridayBanner';
import useIsMobile from 'Hooks/Common/useIsMobile';
import { discountByDuration, PlanDurations } from 'Interfaces/Billing';
import {
  AuthorizedRoutePaths,
  settingsRedirectionMap,
  UnauthorizedRoutePaths,
} from 'Interfaces/RoutePaths';

interface BlackFridayBannerProps {
  isAuthorizedPage?: boolean;
}

const BlackFridayBanner = ({ isAuthorizedPage = true }: BlackFridayBannerProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const [isShowBanner] = useBlackFridayBanner();
  const isShowRedirect = useMemo(() => {
    const path = location.pathname;

    if (
      path === UnauthorizedRoutePaths.SIGN_UP_BUSINESS ||
      path === UnauthorizedRoutePaths.SIGN_UP_PERSONAL
    ) {
      return false;
    }

    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const discount = discountByDuration[PlanDurations.ANNUALLY];

  const handleRedirect = useCallback(() => {
    if (!isAuthorizedPage) {
      return navigate(UnauthorizedRoutePaths.SIGN_UP_BUSINESS);
    }

    navigate(settingsRedirectionMap[AuthorizedRoutePaths.SETTINGS_BILLING_PLAN]);
  }, [navigate, isAuthorizedPage]);

  if (!isShowBanner) {
    return null;
  }

  return (
    <div className={classNames('header__banner', { mobile: isMobile })}>
      <div className="banner__container">
        <div className="banner__title">
          <span className="title__light">
            Black Friday: Get up to {discount}% OFF on our Business Plan
          </span>
        </div>
        {isShowRedirect && (
          <div className="banner__button" onClick={handleRedirect}>
            Save now
          </div>
        )}
      </div>
    </div>
  );
};

export default BlackFridayBanner;
